import data from "../../../../../src/Truncate/Truncate.docs.json";
import * as React from 'react';
export default {
  data,
  React
};